"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
var EditRoadmapController = /** @class */ (function () {
    function EditRoadmapController($state, $q, RoadmapsModel, FlashService, roadmap, sessionTypes, instructors, reportcardTypes, documentTemplates, tasks) {
        var _this = this;
        this.$state = $state;
        this.$q = $q;
        this.RoadmapsModel = RoadmapsModel;
        this.FlashService = FlashService;
        this.roadmap = roadmap;
        this.sessionTypes = sessionTypes;
        this.instructors = instructors;
        this.reportcardTypes = reportcardTypes;
        this.documentTemplates = documentTemplates;
        this.tasks = tasks;
        this.saving = false;
        this.error = "";
        this.onSave = this.save.bind(this);
        this.onCancel = function () { return _this.$state.go("drivecoach.admin.roadmaps.index"); };
    }
    /**
     * Persists the editor payload: updates the name, then diffs the lesson
     * rows against the loaded roadmap — new rows are created, existing rows
     * updated, and rows the admin removed are deleted. Lesson numbers can
     * collide mid-flight when reordering, so deletions run first.
     */
    EditRoadmapController.prototype.save = function (payload) {
        var _this = this;
        this.saving = true;
        this.error = "";
        var roadmapId = this.roadmap.id;
        var keptIds = payload.requirements
            .filter(function (requirement) { return requirement.id; })
            .map(function (requirement) { return requirement.id; });
        var removed = (this.roadmap.requirements || []).filter(function (requirement) { return keptIds.indexOf(requirement.id) === -1; });
        this.$q
            .all(__spreadArray([
            this.RoadmapsModel.update(roadmapId, { name: payload.name })
        ], removed.map(function (requirement) {
            return _this.RoadmapsModel.deleteRequirement(roadmapId, requirement.id);
        }), true))
            .then(function () {
            return _this.$q.all(payload.requirements.map(function (requirement) {
                if (requirement.id) {
                    return _this.RoadmapsModel.updateRequirement(roadmapId, requirement.id, requirement);
                }
                return _this.RoadmapsModel.addRequirement(roadmapId, requirement);
            }));
        })
            .then(function () {
            _this.FlashService.setMessage({
                message: "Roadmap updated successfully.",
                type: "success",
            });
            _this.$state.go("drivecoach.admin.roadmaps.index");
        })
            .catch(function (error) {
            var _a;
            _this.saving = false;
            _this.error =
                ((_a = error === null || error === void 0 ? void 0 : error.data) === null || _a === void 0 ? void 0 : _a.message) ||
                    "Failed to save the roadmap. Check that every lesson has a unique lesson number.";
        });
    };
    return EditRoadmapController;
}());
EditRoadmapController.$inject = [
    "$state",
    "$q",
    "RoadmapsModel",
    "FlashService",
    "roadmap",
    "sessionTypes",
    "instructors",
    "reportcardTypes",
    "documentTemplates",
    "tasks",
];
exports.default = EditRoadmapController;
